import React from 'react';
import { TextField } from '@mui/material';
// import { CustomTextFieldProps } from './types';
import './styles.scss';

const CustomTextField = ({ className, ...props }) => {
    return <TextField className={`custom-textfield-container ${className} `} {...props} />;
};

export default CustomTextField;
